import React, { useState, useRef, useEffect } from "react";
import "./Sitios.css";

const Sitios = () => {
  const images = [
    {
      link: "https://ine.mx",
      src: "https://itetlax.org.mx/assets/img/imgHome/ine.webp",
      alt: "INE"
    },
    {
      link: "https://www.te.gob.mx/",
      src: "https://itetlax.org.mx/assets/img/imgHome/tribunal-electoral.webp",
      alt: "Tribunal Electoral"
    },
    {
      link: "https://www.observatoriomujerestlaxcala.mx/contents/",
      src: "https://itetlax.org.mx/assets/img/imgHome/oppmt.webp",
      alt: "Observatorio de Mujeres"
    },
    {
      link: "https://ine.mx/consulta-infantil-y-juvenil-2024/",
      src: "https://itetlax.org.mx/assets/img/imgHome/VozNinos.webp",
      alt: "Consulta Infantil"
    }
  ];

  const [isPaused, setIsPaused] = useState(false);
  const [currentPosition, setCurrentPosition] = useState(0);
  const trackRef = useRef(null);
  const containerRef = useRef(null);
  const duplicatedImages = [...images, ...images, ...images];

  useEffect(() => {
    if (trackRef.current) {
      const itemWidth = window.innerWidth <= 576 ? containerRef.current.offsetWidth : 320 + 15;
      trackRef.current.style.transform = `translateX(-${currentPosition * itemWidth}px)`;
    }
  }, [currentPosition]);

  return (
    <div className="sitios-container" ref={containerRef}>
      <div 
        className="sitios-carousel-container"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div 
          className="sitios-carousel-track"
          ref={trackRef}
          style={{
            animationPlayState: isPaused ? 'paused' : 'running'
          }}
        >
          {duplicatedImages.map((item, index) => (
            <div 
              key={`${index}-${item.alt}`}
              className="sitios-carousel-item"
              style={window.innerWidth <= 576 ? { minWidth: '100%' } : {}}
            >
              <div className="card h-100">
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-block h-100"
                >
                  <div className="sitios-img-container">
                    <img
                      src={item.src}
                      className="sitios-carousel-img"
                      alt={item.alt}
                    />
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="sitios-dots-container">
        {images.map((_, index) => (
          <button
            key={index}
            className={`sitios-dot ${currentPosition % images.length === index ? 'active' : ''}`}
            onClick={() => setCurrentPosition(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Sitios;